import styled from '@emotion/styled';

import COLOR from '../../../../shared/constant/colorset';
import { addComma } from '../../../../shared/services';
import { getSubPrice, PriceService } from '../../../service/priceService';
import { getDealDisabledText } from '../../shared/utils/productDetailState';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 11.5px 16px;
`;

const Description = styled.p`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const Name = styled.span<{ disabled: boolean }>`
  width: 240px;
  line-height: 16px;
  font-size: 12px;
  letter-spacing: -0.5px;
  overflow-wrap: break-word;
  ${({ disabled }) => disabled && `color: ${COLOR.kurlyGray350}`};
`;

const NotExpectedPointText = styled.span<{ disabled: boolean }>`
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.5px;
  color: ${({ disabled }) => (disabled ? COLOR.kurlyGray350 : COLOR.kurlyGray600)};
  margin-top: 4px;
`;

const PriceWrapper = styled.div`
  display: flex;
  align-self: center;
  flex-shrink: 0;
  gap: 4px;
`;

const BasePrice = styled.div<{ disabled: boolean }>`
  margin-left: 50px;
  text-decoration: line-through;
  font-size: 12px;
  color: ${({ disabled }) => (disabled ? COLOR.kurlyGray350 : COLOR.kurlyGray400)};
`;

const DiscountedPrice = styled.div<{ disabled: boolean }>`
  font-size: 12px;
  font-weight: bold;
  letter-spacing: -0.5px;
  color: ${({ disabled }) => (disabled ? COLOR.kurlyGray350 : COLOR.kurlyGray800)};
`;

interface Props {
  description: string | null;
  basePrice: number;
  retailPrice: number | null;
  discountedPrice: number | null;
  isSoldOut: boolean;
  isPurchaseStatus: boolean;
  isExpectedPoint?: boolean;
  isGroupProduct?: boolean;
}

export default function DropdownItem({
  description,
  basePrice,
  retailPrice,
  discountedPrice,
  isSoldOut,
  isPurchaseStatus,
  isExpectedPoint = true,
  isGroupProduct = false,
}: Props) {
  const { representativePrice, kurlyPrice, originalPrice } = new PriceService({
    retailPrice,
    basePrice,
    discountedPrice,
  });

  const subPrice = getSubPrice({ originalPrice, kurlyPrice });

  const disabledText = getDealDisabledText({ isPurchaseStatus, isSoldOut });

  const disabled = isSoldOut || !isPurchaseStatus;

  return (
    <Container onClick={(e) => disabled && !isGroupProduct && e.stopPropagation()}>
      <Description>
        <Name disabled={disabled}>
          {disabledText && `(${disabledText}) `}
          {description}
        </Name>
        {!isExpectedPoint && <NotExpectedPointText disabled={disabled}>적립제외상품</NotExpectedPointText>}
      </Description>
      {!!representativePrice && (
        <PriceWrapper>
          {!!subPrice && <BasePrice disabled={disabled}>{`${addComma(subPrice)}원`}</BasePrice>}
          <DiscountedPrice disabled={disabled}>{`${addComma(representativePrice)}원`}</DiscountedPrice>
        </PriceWrapper>
      )}
    </Container>
  );
}
